import {createEntityService} from 'utils/createEntityService';
import {VisitDocument} from 'types/visitDocument';
import apiClient from './apiClient';

export const BaseVisitDocumentService = createEntityService<VisitDocument>({
  baseUrl: 'api/v1/visit_documents',
  entityName: 'visitDocument',
});

export class VisitDocumentService extends BaseVisitDocumentService {
  static complete(entity: VisitDocument) {
    const data = entity.toJson();
    return apiClient.patch(
      `api/v1/visit_documents/${data.id}/complete`,
      {
        visit_document: data,
      },
    );
  }
}
